// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hOGsV","content":"styles_content__28pFx","row":"styles_row__3le1v","footer":"styles_footer__11uLF","phraseLength":"styles_phraseLength__1wnEG"};